import type { ElementType } from "react";
import type { ActivitySummary } from "@/lib/types";

const CAT_STYLE: Record<string, { bg: string; border: string; text: string; dot: string }> = {
  Carrera:  { bg: "bg-orange-500/12", border: "border-orange-500/30", text: "text-orange-600 dark:text-orange-400", dot: "bg-orange-400" },
  Ciclismo: { bg: "bg-sky-500/12",    border: "border-sky-500/30",    text: "text-sky-600 dark:text-sky-400",       dot: "bg-sky-400" },
  Natacion: { bg: "bg-blue-500/12",   border: "border-blue-500/30",   text: "text-blue-600 dark:text-blue-400",     dot: "bg-blue-400" },
  Hybrid:   { bg: "bg-violet-500/12", border: "border-violet-500/30", text: "text-violet-600 dark:text-violet-400", dot: "bg-violet-400" },
  Hike:     { bg: "bg-lime-500/12",   border: "border-lime-500/30",   text: "text-lime-600 dark:text-lime-400",     dot: "bg-lime-500" },
};
const DEFAULT_STYLE = { bg: "bg-emerald-500/12", border: "border-emerald-500/30", text: "text-emerald-600 dark:text-emerald-400", dot: "bg-emerald-400" };

export default function ActivityCard({
  act,
  onOpen,
  openHint,
}: {
  act: ActivitySummary;
  onOpen?: (categoria: string) => void;
  openHint?: string;
}) {
  const style = CAT_STYLE[act.categoria] ?? DEFAULT_STYLE;
  const parts: string[] = [];
  if (act.distance_km) parts.push(`${act.distance_km.toFixed(1)} km`);
  if (act.duration_min) parts.push(`${Math.round(act.duration_min)}'`);

  const Tag = (onOpen ? "button" : "div") as ElementType;
  return (
    <Tag
      onClick={onOpen ? () => onOpen(act.categoria) : undefined}
      title={onOpen ? openHint : undefined}
      className={`w-full rounded-lg border p-1.5 text-left text-[11px] transition ${style.bg} ${style.border} ${
        onOpen ? "cursor-pointer hover:brightness-95" : ""
      }`}
    >
      <div className="flex items-center gap-1 truncate">
        <span className={`inline-block h-1.5 w-1.5 shrink-0 rounded-full ${style.dot}`} aria-hidden />
        <span className="truncate font-semibold text-fg leading-snug">{act.name || act.categoria}</span>
      </div>
      {parts.length > 0 && (
        <p className={`mt-0.5 text-[10px] font-medium ${style.text}`}>
          {parts.join(" · ")}
        </p>
      )}
    </Tag>
  );
}
